import { ServiceProviderType, YesNo } from "@/types";
import { FieldRow, FieldsTable } from "@/components/molecules/FieldsTable";
import { NotAvailable } from "../../Dashboard/RequestDetails/NotAvailable";
import { PersonDetails } from "./PersonDetails";
import { readableAccountNextSteps, readableAccountType } from "@/utils/accounts";
import { AccountDisplayInfo } from "@/pages/NotifierForm/Submit/AccountDetails/AccountDetails";

export const InvestmentsAccount = ({
  account,
  serviceProviderType,
}: {
  account: any;
  serviceProviderType: ServiceProviderType;
}) => {
  return (
    <>
      <FieldRow label="Joint account?" value={account?.jointClaim === YesNo.Yes ? "Yes" : "No"} />
      <FieldRow
        label="Next step"
        value={readableAccountNextSteps(account?.nextStep, serviceProviderType)}
      />
      {account?.responsible?.id && (
        <FieldRow
          label="Responsible"
          value={
            account?.responsible?.id === "notifier" ? (
              "Myself"
            ) : (
              <PersonDetails person={account?.responsible.details} />
            )
          }
        />
      )}
    </>
  );
};

export const QuilterAccountSummary = ({ account, serviceProviderType }: AccountDisplayInfo) => {
  return (
    <>
      <FieldRow label="Head Account Number" value={account?.accountNumber} />
      <FieldRow label="Account Type" value={readableAccountType(account?.accountType, "")} />
      <FieldRow label="Sub Account Number" value={account?.holderNumber} />
      <FieldRow
        label="Next step"
        value={readableAccountNextSteps(
          account?.nextSteps ?? account?.nextStep,
          serviceProviderType
        )}
      />
      <FieldRow
        label="Did the death occur in the UK?"
        value={account?.isPlaceOfDeathUk ? "Yes" : "No"}
      />
      {account?.isPlaceOfDeathUk && (
        <FieldRow
          label="Assets over £100k or offshore over £30k?"
          value={account?.assetsValueAboveThreshold ? "Yes" : "No"}
        />
      )}
    </>
  );
};

export const NEQuilterAccountSummary = ({ account, serviceProviderType }: AccountDisplayInfo) => {
  return (
    <FieldsTable>
      <FieldRow label="Head Account Number" value={account?.accountNumber} />
      <FieldRow label="Account Type" value={readableAccountType(account?.accountType, "")} />
      <FieldRow label="Sub Account Number" value={account?.holderNumber} />
      <FieldRow
        label="Next step"
        value={readableAccountNextSteps(
          account?.nextSteps ?? account?.nextStep,
          serviceProviderType
        )}
      />
      <FieldRow
        label="Did the death occur in the UK?"
        value={account?.isPlaceOfDeathUk ? "Yes" : "No"}
      />

      {account?.isPlaceOfDeathUk && (
        <FieldRow
          label="Assets over £100k or offshore over £30k?"
          value={account?.assetsValueAboveThreshold ? "Yes" : "No"}
        />
      )}
    </FieldsTable>
  );
};
